<template>
  <div class="bidListMgmt-container">
    <!-- 表格区域 -->
    <div class="table-container">
      <el-table :data="tableData" border style="width: 100%" max-height="calc(100vh - 200px)"
        :header-cell-style="{ backgroundColor: '#f5f7fa', color: '#606266' }" :cell-style="{ color: '#303133' }">
        <el-table-column label="序号" width="80" align="center">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="bidSectionName" label="标段名称"></el-table-column>
        <el-table-column prop="tendereeName" label="招标人"></el-table-column>
        <el-table-column prop="agencyName" label="代理机构"></el-table-column>
        <el-table-column prop="region" label="地区"></el-table-column>
        <el-table-column prop="classifyName" label="行业"></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="primary" size="small" @click="handleStartEvaluation(scope.row)" class="action-btn">
              开始评标
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 承诺书弹窗 -->
    <el-dialog :title="currentCommitment.title" :visible.sync="dialogVisible" width="60%" :close-on-click-modal="false"
      :close-on-press-escape="false" custom-class="commitment-dialog" @close="handleDialogClose">
      <div class="commitment-content">
        <!-- 承诺书头部信息 -->
        <div class="commitment-header">
          <div class="project-info">
            <h4>{{ bidSectionName }}</h4>
            <p class="project-meta">{{ formatDate(new Date()) }}</p>
          </div>
          <div class="commitment-type">
            <el-tag :type="currentCommitment.tagType" size="medium">
              {{ currentCommitment.category }}
            </el-tag>
          </div>
        </div>
        <!-- 承诺书内容区域 -->
        <div class="commitment-body">
          <div class="commitment-text" v-html="currentCommitment.content"></div>
        </div>
        <!-- 承诺确认提示 -->
        <div class="commitment-notice" v-if="!isCommitted">
          <el-alert title="重要提醒" type="warning" :closable="false" show-icon>
            <template slot="default">
              请仔细阅读以上承诺内容，确认无误后点击"确认承诺"按钮。
              一旦确认，将视为您已充分理解并同意遵守相关承诺。
            </template>
          </el-alert>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancel" :disabled="isCommitted" size="medium">
          {{ isCommitted ? '已承诺' : '取消' }}
        </el-button>
        <el-button type="primary" @click="handleCommit" :loading="commitLoading" size="medium">
          {{ isCommitted ? '进入评标' : '确认承诺' }}
        </el-button>
      </span>
    </el-dialog>
    <!-- 推荐组长弹窗 -->
    <div v-if="showRecommendDialog" class="recommend-dialog-overlay">
      <div class="recommend-dialog" @click.stop>
        <div class="recommend-dialog-content">
          <div class="recommend-dialog-header">
            <div class="title-section">
              <div class="title-bar"></div>
              <h3 class="dialog-title">推荐组长</h3>
            </div>
            <button class="new-file-btn" @click="showPreview">预览文件</button>
          </div>
          <div class="instruction-text">
            评委委员会共{{ expertData.expertCount || 0 }}人，当前已登录{{ expertList.length }}人，请选择您要推荐的组长
          </div>
          <div class="selection-options">
            <div class="expert-card" v-for="expert in expertList" :key="expert.expertId"
              :class="{ active: selectedLeader === expert.expertId }" @click="selectLeader(expert.expertId)">
              <div class="expert-info">
                <div class="expert-name">{{ expert.expertName }}</div>
                <div class="expert-details">
                  <div class="expert-unit">身份:{{ expert.identity == 0 ? '专家' : '甲方代表' }}</div>
                  <div class="expert-unit">专业:{{ expert.industryName }}</div>
                  <!-- <div class="expert-title">职称：{{ expert.professionalTitle }}</div> -->
                </div>
              </div>
            </div>
          </div>
          <div class="save-section">
            <button class="save-btn" @click="saveRecommendation" :disabled="saveLoading"
              :style="saveLoading ? 'opacity:0.6;cursor:not-allowed;' : ''">{{ saveLoading ? '提交中...' : '保存' }}</button>
          </div>
        </div>
      </div>
    </div>
    <!-- 推荐结果弹窗 -->
    <div v-if="showResultDialog" class="result-dialog-overlay">
      <div class="result-dialog" @click.stop>
        <div class="result-dialog-content">
          <div class="result-dialog-header">
            <div class="title-section">
              <div class="title-bar"></div>
              <h3 class="dialog-title">推荐组长</h3>
            </div>
          </div>
          <div class="candidates-section">
            <div class="candidate-item" v-for="expert in voteResult" :key="expert.voteForExpertId">
              <div class="candidate-name">{{ expert.voteForExpertName }}</div>
              <div class="vote-count">票数: {{ expert.voteCount || 0 }}</div>
            </div>
          </div>
          <div class="vote-result">
            <div class="result-text">
              根据投票结果,组长为:{{ complete == 0 ? "正在投票.." : selectedLeaderName }}
            </div>
          </div>
          <div class="start-section">
            <button class="start-btn" @click="startEvaluation" :disabled="startEvalLoading"
              :style="startEvalLoading ? 'opacity:0.6;cursor:not-allowed;' : ''">{{ startEvalLoading ? '跳转中...' : '开始评标' }}</button>
          </div>
        </div>
      </div>
    </div>
    <!-- 回避单位弹窗 -->
    <el-dialog title="" :visible.sync="showAvoidDialog" width="600px" :close-on-click-modal="false"
      :close-on-press-escape="false" :show-close="false" custom-class="avoid-dialog">
      <div class="avoid-content">
        <h3 class="avoid-title">回避单位</h3>
        <div class="avoid-section">
          <div class="avoid-label">招标人</div>
          <div class="avoid-value-box">{{ avoidInfo.tendererName }}</div>
        </div>
        <div class="avoid-section">
          <div class="avoid-label">招标代理机构</div>
          <div class="avoid-value-box">{{ avoidInfo.agentName }}</div>
        </div>
        <el-table :data="avoidCompanyTableData" border style="width: 100%; margin-top: 16px;"
          :header-cell-style="{ backgroundColor: '#f0f0f0', color: '#333', fontWeight: 'bold' }">
          <el-table-column prop="index" label="序号" width="80" align="center"></el-table-column>
          <el-table-column prop="name" label="单位名称"></el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="avoid-footer">
        <el-button type="danger" @click="handleAvoidExit" :loading="avoidExitLoading">回避并退出评标</el-button>
        <el-button type="primary" @click="handleNoAvoid">无需回避，进入评标</el-button>
      </div>
    </el-dialog>

    <!-- 预览文件弹窗 -->
    <div v-if="showPreviewDialog" class="preview-dialog-overlay">
      <div class="preview-dialog" @click.stop>
        <div class="preview-dialog-content">
          <div class="preview-dialog-header">
            <div class="title-section">
              <div class="title-bar"></div>
              <h3 class="dialog-title">预览文件</h3>
            </div>
            <div class="preview-actions">
              <button class="recommend-btn" @click="handleRecommend">
                当前评委会总数{{ expertData.expertCount || 0 }}人，已到场专家{{ expertList.length }}人
              </button>
            </div>
          </div>
          <div class="file-selection-section">
            <div class="selection-row">
              <span class="selection-label">选择要预览的文件:</span>
              <el-radio-group v-model="selectedFileType" class="file-radio-group">
                <el-radio label="bidding">招标文件</el-radio>
                <el-radio label="tender">投标文件</el-radio>
              </el-radio-group>
              <el-select v-model="selectedCompany" class="company-select" placeholder="选择公司"
                @change="handleBidderChange">
                <el-option v-for="item in bidderOptions" :key="item.userId" :label="item.userName"
                  :value="item.userId"></el-option>
              </el-select>
            </div>
          </div>
          <div class="preview-content">
            <PdfViewer :pdf-url="getPdfUrl()" :show-toolbar="true" :initial-scale="1.0" @pdf-loaded="onPdfLoaded"
              @pdf-error="onPdfError" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getCommitteeSectionList,
  read,
  getBidderList,
  getBidderFile,
  getEvaluationExpertList,
  getVoteBidder,
  getComplete,
  saveComplete,
  getVoteResult,
  getEvaluationInfo,
  getAvoidInfo,
  getAvoidInfoByExpert
} from '@/api/modules/evaluation'
import { getInvitationMain } from '@/api/modules/make'
import Cookies from 'js-cookie'
import PdfViewer from '@/components/common/PdfViewer.vue'
export default {
  components: {
    PdfViewer
  },
  data() {
    return {
      tableData: [],// 表格数据
      dialogVisible: false,
      bidSectionName: '',
      sectionCode: '',

      // 回避弹窗相关
      showAvoidDialog: false,
      avoidInfo: {
        tendererName: '',
        agentName: '',
        companyList: []
      },

      // 登陆后业务状态
      showPreviewDialog: false,
      showRecommendDialog: false,
      showResultDialog: false,
      selectedLeader: null,
      selectedFileType: 'bidding',
      selectedCompany: '1',
      pdfUrl: '',
      expertList: [],
      bidderOptions: [],
      voteResult: [],
      voteResultTimer: null,
      expertListTimer: null,
      complete: 0,
      // 防重复点击 / inflight 守卫
      saveLoading: false,
      startEvalLoading: false,
      avoidExitLoading: false,
      expertListFetching: false,
      voteResultFetching: false,
      saveCompletePending: false,
      selectedLeaderName: '',
      expertData: {},

      // 承诺书相关数据
      isCommitted: false,
      commitLoading: false,
      currentCommitmentType: 'expert', // 当前承诺书类型

      // 承诺书配置
      commitmentTypes: {
        expert: {
          title: '评标专家承诺书',
          category: '专家承诺',
          tagType: 'primary',
          content: `
            <div class="commitment-intro">
              <p>本人参加<strong>{{bidSectionName}}</strong>的评标活动，郑重承诺如下：</p>
            </div>
            <div class="commitment-items">
              <div class="commitment-item">
                <span class="item-number">一、</span>
                <span class="item-content">身体状态良好，精神状态佳，能够承担评标工作，保证在评标过程中保持专业判断能力；</span>
              </div>
              <div class="commitment-item">
                <span class="item-number">二、</span>
                <span class="item-content">熟知国家及本省、市建设工程招投标方面的法律、法规、规章和规范性文件的相关规定，能够按照相关要求客观、公正、独立地履行评标专家职责；</span>
              </div>
              <div class="commitment-item">
                <span class="item-number">三、</span>
                <span class="item-content">不存在法律、法规、规章及规范性文件规定应当回避的情形，与参与投标的单位及人员无任何利益关系；</span>
              </div>
              <div class="commitment-item">
                <span class="item-number">四、</span>
                <span class="item-content">严格遵守评标纪律，不泄露评标过程中的任何信息，不接受任何单位或个人的请托或贿赂；</span>
              </div>
              <div class="commitment-item">
                <span class="item-number">五、</span>
                <span class="item-content">认真履行评标职责，独立进行评标，不受任何单位或个人的干扰，确保评标结果的公正性。</span>
              </div>
            </div>
            <div class="commitment-footer">
              <p><strong>特此承诺。</strong></p>
            </div>
          `
        },
      }
    }
  },
  computed: {
    // Cookie 访问器，集中管理，避免分散硬编码
    committeeId() { return Cookies.get('committeeId') || '' },
    evaluationId() { return Cookies.get('evaluationId') || '' },
    bidSectionCode() { return Cookies.get('bidSectionCode') || '' },

    // 回避单位表格数据
    avoidCompanyTableData() {
      return this.avoidInfo.companyList.map((name, i) => ({ index: i + 1, name }))
    },

    // 当前承诺书配置
    currentCommitment() {
      const commitment = this.commitmentTypes[this.currentCommitmentType] || this.commitmentTypes.expert
      const content = commitment.content.replace(/\{\{bidSectionName\}\}/g, this.bidSectionName || '本项目')
      return { ...commitment, content }
    },
  },
  watch: {
    // 监听文件类型变化，重新获取PDF
    selectedFileType() {
      this.refreshPdfUrl()
    }
  },
  mounted() {
    this.initData()
    this.getComplete()
  },
  beforeDestroy() {
    this.clearVoteResultTimer()
    this.clearExpertListTimer()
  },
  methods: {


        // 获取专家信息
        async getEvaluationInfo() {
      const res = await getEvaluationInfo()
      if (res && res.code === 200) {
        Cookies.set('role', res.data.role)
        Cookies.set('title', res.data.sectionName)
      } else {
        this.$message.error((res && res.msg) || '获取专家信息失败')
      }
    },
    // 加载回避信息
    loadAvoidInfo() {
      const sectionCode = this.bidSectionCode
      if (!sectionCode) return
      getAvoidInfo(sectionCode).then(res => {
        if (res.code === 200 && res.data) {
          this.avoidInfo = {
            tendererName: res.data.tendererName || '',
            agentName: res.data.agentName || '',
            companyList: Array.isArray(res.data.companyList) ? res.data.companyList : []
          }
          this.showAvoidDialog = true
        } else {
          // 无回避数据，直接进入下一步
          this.saveComplete(1)
          this.startExpertListTimer()
        }
      }).catch(err => {
        console.error('获取回避信息失败:', err)
        // 失败时也进入下一步
        this.startExpertListTimer()
      })
    },
    // 回避并退出评标
    handleAvoidExit() {
      if (this.avoidExitLoading) return
      if (!this.committeeId || !this.evaluationId) {
        this.$message.error('缺少参数')
        return
      }
      this.avoidExitLoading = true
      getAvoidInfoByExpert(this.committeeId, this.evaluationId).then(res => {
        if (res.code === 200) {
          this.$message.success('已回避并退出评标')
          this.showAvoidDialog = false
          Cookies.remove('token')
          this.$router.push({ path: '/login' })
        } else {
          this.$message.error(res.msg || '回避操作失败')
        }
      }).catch(err => {
        console.error('回避操作失败:', err)
        this.$message.error('回避操作失败')
      }).finally(() => {
        this.avoidExitLoading = false
      })
    },
    // 无需回避，进入评标
    handleNoAvoid() {
      this.showAvoidDialog = false
      this.saveComplete(1)
      this.startExpertListTimer()
    },
    //  初始化页面数据
    initData() {
      this.getCommitteeSectionList()
    },
    //获取评标室下的标段列表-招标列表接口
    getCommitteeSectionList() {
      getCommitteeSectionList(this.committeeId).then(res => {
        if (res.code === 200) {
          let arr = res.data;
          if (!arr || arr.length === 0) {
            this.$message.error('当前评标室下暂无数据')
            return
          }
          arr.forEach(item => {
            item.region = item.projectLocationProvince + '/' + item.projectLocationCity + '/' + item.projectLocation
          })
          this.tableData = arr
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 开始评标
    handleStartEvaluation(row) {
      this.getEvaluationInfo()
      Cookies.set('title', row.bidSectionName)
      this.sectionCode = row.bidSectionCode
      this.bidSectionName = row.bidSectionName
      if (row.read) {
        this.navigateToEvaluation()
      } else {
        this.resetCommitmentState()
        this.dialogVisible = true
      }
    },
    // 专家确认承诺
    read() {
      return read({ sectionCode: this.sectionCode }).then(res => {
        if (res.code === 200) {
          this.commitLoading = true
          this.isCommitted = true
          this.$message.success('承诺确认成功')
        } else {
          this.$message.error(res.msg)
        }
      })
    },

    // 重置承诺状态
    resetCommitmentState() {
      this.isCommitted = false
      this.commitLoading = false
      this.currentCommitmentType = 'expert'
    },

    // 处理承诺确认
    async handleCommit() {
      if (this.isCommitted) {
        // 已承诺，跳转到评标页面
        this.navigateToEvaluation()
        return
      }

      try {
        await this.read()
        // 延迟跳转，让用户看到成功提示
        setTimeout(() => {
          this.navigateToEvaluation()
        }, 1500)

      } catch (error) {
        console.error('承诺确认失败:', error)
        this.$message.error('承诺确认失败，请重试')
      } finally {
        this.commitLoading = false
      }
    },

    // 跳转到评标页面
    navigateToEvaluation() {
      this.dialogVisible = false
      Cookies.set('pushSectionCode', this.sectionCode)
      this.$router.push({ path: '/expertEvaluation/evaluationPage', query: { pushSectionCode: this.sectionCode } })
    },

    // 处理取消
    handleCancel() {
      if (this.isCommitted) return

      this.dialogVisible = false
      this.resetCommitmentState()
    },

    // 处理弹窗关闭
    handleDialogClose() {
      if (!this.isCommitted) {
        this.handleCancel()
      }
    },

    // 格式化日期
    formatDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}年${month}月${day}日`
    },

    /* ==================== 登陆后业务逻辑 ==================== */
    clearAllTimers() {
      this.clearVoteResultTimer()
      this.clearExpertListTimer()
    },
    handleBidderChange(value) {
      this.selectedCompany = value
      this.refreshPdfUrl()
    },
    refreshPdfUrl() {
      if (this.selectedFileType === 'bidding') {
        this.getInvitationMain()
      } else {
        this.getBidderFile()
      }
    },
    // 获取完成到哪一步
    getComplete() {
      if (!this.committeeId || !this.evaluationId) {
        return
      }
      getComplete({ committeeId: this.committeeId, expertId: this.evaluationId }).then(res => {
        if (res.code === 200) {

          console.log('------获取到了哪一步---->',res.data.complete);
          
          if (res.data) {
            switch (res.data.complete) {
              case 0:
                // 回避步骤
                this.loadAvoidInfo()
                break
              case 1:
                // 推荐组长
                this.startExpertListTimer()
                break
              case 2:
                // 投票结果
                this.startVoteResultTimer()
                this.showResultDialog = true
                this.showRecommendDialog = false
                break
              case 3:
                // 已进入评标阶段，保持在当前招标列表页
                break
              default:
                // 初始状态，加载回避信息
                this.loadAvoidInfo()
                break
            }
          } else {
            // 无数据，从第一步回避开始
            this.loadAvoidInfo()
          }
        } else {
          this.clearAllTimers()
          this.$message.error(res.msg)
        }
      }).catch(err => {
        this.clearAllTimers()
         this.loadAvoidInfo()
        console.log('获取完成步骤失败:', err)
      })
    },
    // 获取评标室专家列表
    getEvaluationExpertList() {
      if (this.expertListFetching) return
      this.expertListFetching = true
      getEvaluationExpertList(this.committeeId).then(res => {
        if (res.code === 200) {
          this.expertData = res.data
          this.showRecommendDialog = true
          this.expertList = res.data.expertList
        } else {
          this.clearExpertListTimer()
          this.$message.error(res.msg)
        }
      }).catch(err => {
        this.clearExpertListTimer()
        console.log('获取评标室专家列表失败:', err)
      }).finally(() => {
        this.expertListFetching = false
      })
    },
    startExpertListTimer() {
      this.clearExpertListTimer()
      this.getEvaluationExpertList()
      this.expertListTimer = setInterval(() => {
        this.getEvaluationExpertList()
      }, 2000)
    },
    clearExpertListTimer() {
      if (this.expertListTimer) {
        clearInterval(this.expertListTimer)
        this.expertListTimer = null
      }
    },
    // 预览文件
    showPreview() {
      this.showPreviewDialog = true
      this.showRecommendDialog = false
      this.getBidderList()
    },
    getBidderList() {
      let data = {
        sectionCode: Cookies.get('pushSectionCode')
      }
      getBidderList(data).then(res => {
        if (res.code === 200) {
          if (res.data.length > 0) {
            this.selectedCompany = res.data[0].userId
            this.refreshPdfUrl()
          }
          this.bidderOptions = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    getBidderFile() {
      getBidderFile({
        userId: this.selectedCompany,
        sectionCode: this.bidSectionCode
      }).then(res => {
        if (res.code === 200) {
          this.pdfUrl = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    getInvitationMain() {
      getInvitationMain(this.bidSectionCode).then(res => {
        if (res.code === 200) {
          this.pdfUrl = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    handleRecommend() {
      this.showPreviewDialog = false
      this.showRecommendDialog = true
    },
    getPdfUrl() {
      return this.pdfUrl || ''
    },
    onPdfLoaded(info) {
      console.log('PDF加载完成:', info)
    },
    onPdfError(error) {
      console.error('PDF加载失败:', error)
      this.$message.error('PDF文件加载失败')
    },
    selectLeader(expertId) {
      this.selectedLeader = expertId
    },
    saveRecommendation() {
      if (this.saveLoading) return
      if (!this.selectedLeader) {
        this.$message.warning('请选择要推荐的组长')
        return
      }
      this.recommendLeader()
    },
    recommendLeader() {
      this.saveLoading = true
      getVoteBidder({
        committeeId: this.committeeId,
        voteExpertId: this.evaluationId,
        voteForExpertId: this.selectedLeader
      }).then(res => {
        if (res.code === 200) {
          this.$message.success('推荐成功')
          this.clearExpertListTimer()
          this.startVoteResultTimer()
          this.showResultDialog = true
           this.showRecommendDialog = false
          this.saveComplete(2)
        } else {
          this.loadAvoidInfo()
          this.clearAllTimers()
          this.showResultDialog = false
          this.showResultDialog = false
          this.showRecommendDialog = false
          this.$message.error(res.msg)
        }
      }).catch(err => {
        this.clearAllTimers()
        console.log('推荐组长失败:', err)
      }).finally(() => {
        this.saveLoading = false
      })
    },
    getVoteResult() {
      if (this.voteResultFetching) return
      this.voteResultFetching = true
      getVoteResult({ committeeId: this.committeeId }).then(res => {
        if (res.code === 200) {
          this.voteResult = res.data.detail
          this.complete = res.data.complete
          this.selectedLeaderName = res.data.max && res.data.max.voteForExpertName
          if (this.complete === 1) {
            this.clearVoteResultTimer()
          }
        } else {
          this.clearAllTimers()
          this.showResultDialog = false
          this.$message.error(res.msg)
          this.getComplete()
        }
      }).catch(err => {
        this.clearAllTimers()
        console.log('获取投票结果失败:', err)
      }).finally(() => {
        this.voteResultFetching = false
      })
    },
    startEvaluation() {
      if (this.startEvalLoading) return
      if (this.complete === 0) {
        this.$message.warning('投票未完成～')
        return
      }
      this.startEvalLoading = true
      this.saveComplete(3)
      this.showResultDialog = false
    },
    startVoteResultTimer() {
      this.clearVoteResultTimer()
      this.getVoteResult()
      this.voteResultTimer = setInterval(() => {
        this.getVoteResult()
      }, 10000)
    },
    clearVoteResultTimer() {
      if (this.voteResultTimer) {
        clearInterval(this.voteResultTimer)
        this.voteResultTimer = null
      }
    },
    saveComplete(vl) {
      if (this.saveCompletePending) return
      this.saveCompletePending = true
      saveComplete({
        committeeId: this.committeeId,
        expertId: this.evaluationId,
        complete: vl
      }).then(res => {
        if (res.code !== 200) {
          this.clearAllTimers()
          this.$message.error(res.msg)
        }
      }).catch(err => {
        this.clearAllTimers()
        console.log('保存步骤失败:', err)
      }).finally(() => {
        this.saveCompletePending = false
        this.startEvalLoading = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
.bidListMgmt-container {
  width: 100%;
  height: 80vh;
  padding: 20px;
  background-color: white;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .table-container {
    flex: 1;
    margin-bottom: 20px;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    .action-btn {
      background-color: #409eff;
      border-color: #409eff;
      color: white;
      font-size: 12px;
      padding: 5px 15px;
      border-radius: 4px;
      transition: all 0.25s;

      &:hover {
        background-color: #66b1ff;
        border-color: #66b1ff;
      }
    }
  }
}

// 承诺书弹窗样式
/deep/ .commitment-dialog {
  .el-dialog__header {
    color: black;
    padding: 20px 24px;
    border-radius: 8px 8px 0 0;

    .el-dialog__title {
      font-size: 18px;
      font-weight: 600;
      color: black;
    }

    .el-dialog__close {
      color: white;
      font-size: 20px;

      &:hover {
        color: #f0f0f0;
      }
    }
  }

  .el-dialog__body {
    padding: 0;
    max-height: 70vh;
    overflow-y: auto;
  }

  .el-dialog__footer {
    padding: 20px 24px;
    background: #f8f9fa;
    border-radius: 0 0 8px 8px;
    text-align: center;

    .el-button {
      min-width: 120px;
      margin: 0 8px;
    }
  }
}

.commitment-content {
  padding: 24px;

  .commitment-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 24px;
    padding-bottom: 16px;
    border-bottom: 2px solid #e9ecef;

    .project-info {
      flex: 1;

      h4 {
        margin: 0 0 8px 0;
        font-size: 16px;
        font-weight: 600;
        color: #2c3e50;
        line-height: 1.4;
      }

      .project-meta {
        margin: 0;
        font-size: 14px;
        color: #6c757d;
      }
    }

    .commitment-type {
      flex-shrink: 0;
      margin-left: 16px;
    }
  }

  .commitment-body {
    .commitment-text {
      margin-bottom: 24px;

      .commitment-intro {
        margin-bottom: 20px;

        p {
          margin: 0;
          font-size: 15px;
          line-height: 1.6;
          color: #2c3e50;
          font-weight: 500;
        }
      }

      .commitment-items {
        margin-bottom: 20px;

        .commitment-item {
          display: flex;
          margin-bottom: 16px;
          padding: 12px 16px;
          background: #f8f9fa;
          border-radius: 8px;
          border-left: 4px solid #007bff;

          .item-number {
            flex-shrink: 0;
            font-weight: 600;
            color: #007bff;
            margin-right: 12px;
            min-width: 24px;
          }

          .item-content {
            flex: 1;
            font-size: 14px;
            line-height: 1.6;
            color: #495057;
          }
        }
      }

      .commitment-footer {
        text-align: center;
        margin-top: 20px;

        p {
          margin: 0;
          font-size: 15px;
          color: #2c3e50;
        }
      }
    }

  }

  .commitment-notice {
    margin-top: 20px;

    /deep/ .el-alert {
      border-radius: 8px;
      border: none;

      .el-alert__content {
        .el-alert__title {
          font-weight: 600;
          margin-bottom: 8px;
        }

        .el-alert__description {
          font-size: 14px;
          line-height: 1.6;
        }
      }
    }
  }
}

/* ==================== 登陆后弹窗样式 ==================== */
.recommend-dialog-overlay,
.result-dialog-overlay,
.preview-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.recommend-dialog,
.result-dialog {
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  width: 500px;
  max-width: 90vw;
}

.preview-dialog {
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  width: 90vw;
  max-width: 1200px;
  height: 80vh;
  max-height: 800px;
  display: flex;
  flex-direction: column;
}

.recommend-dialog-content,
.result-dialog-content {
  text-align: start;
  padding: 20px;

  .recommend-dialog-header,
  .result-dialog-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    .title-section {
      display: flex;
      align-items: center;

      .title-bar {
        width: 4px;
        height: 20px;
        background-color: #409EFF;
        margin-right: 10px;
        border-radius: 2px;
      }

      .dialog-title {
        margin: 0;
        font-size: 16px;
        font-weight: 500;
        color: #333;
      }
    }

    .new-file-btn {
      background-color: #409EFF;
      color: white;
      border: none;
      padding: 8px 16px;
      border-radius: 4px;
      font-size: 14px;
      cursor: pointer;
      transition: background-color 0.3s;

      &:hover {
        background-color: #66b1ff;
      }
    }
  }

  .instruction-text {
    font-size: 14px;
    color: #666;
    margin-bottom: 20px;
    line-height: 1.5;
  }

  .selection-options {
    margin-bottom: 30px;
    display: flex;
    flex-direction: column;
    gap: 12px;

    .expert-card {
      padding: 16px;
      background-color: #f8f9fa;
      border: 2px solid #e0e0e0;
      border-radius: 8px;
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        background-color: #e8f4ff;
        border-color: #409EFF;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(64, 158, 255, 0.15);
      }

      &.active {
        background-color: #409EFF;
        border-color: #409EFF;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);

        .expert-name {
          color: white;
        }

        .expert-details .expert-unit,
        .expert-details .expert-title {
          color: rgba(255, 255, 255, 0.9);
        }
      }

      .expert-info {
        .expert-name {
          font-size: 16px;
          font-weight: 600;
          color: #333;
          margin-bottom: 8px;
        }

        .expert-details .expert-unit,
        .expert-details .expert-title {
          font-size: 14px;
          color: #666;
          line-height: 1.4;
          margin-bottom: 4px;
        }
      }
    }
  }

  .save-section,
  .start-section {
    text-align: center;

    .save-btn,
    .start-btn {
      width: 120px;
      height: 40px;
      background-color: #409EFF;
      color: white;
      border: none;
      border-radius: 6px;
      font-size: 14px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.25s;

      &:hover {
        background-color: #66b1ff;
      }

      &:active {
        background-color: #3a8ee6;
      }
    }
  }

  .candidates-section {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 15px;
    margin-bottom: 20px;

    .candidate-item {
      background-color: #f5f5f5;
      border: 1px solid #e0e0e0;
      border-radius: 8px;
      text-align: center;
      overflow: hidden;
      transition: box-shadow 0.25s;

      &:hover {
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
      }

      .candidate-name {
        font-size: 14px;
        color: #333;
        padding: 12px 12px 8px;
        font-weight: 500;
      }

      .vote-count {
        width: 100%;
        background-color: rgba(7, 221, 218, 1);
        padding: 8px;
        font-size: 12px;
        color: #333;
        font-weight: 500;
      }
    }
  }

  .vote-result {
    margin-bottom: 20px;

    .result-text {
      background-color: #fff2f0;
      border: 1px solid #ffccc7;
      border-radius: 6px;
      padding: 12px 16px;
      font-size: 14px;
      color: #ff4d4f;
      text-align: center;
      font-weight: 500;
    }
  }
}

.preview-dialog-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;

  .preview-dialog-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 15px;
    border-bottom: 1px solid #e0e0e0;

    .title-section {
      display: flex;
      align-items: center;

      .title-bar {
        width: 4px;
        height: 20px;
        background-color: #409EFF;
        margin-right: 10px;
        border-radius: 2px;
      }

      .dialog-title {
        margin: 0;
        font-size: 18px;
        font-weight: 500;
        color: #333;
      }
    }
  }

  .file-selection-section {
    margin-bottom: 20px;

    .selection-row {
      display: flex;
      align-items: center;
      gap: 15px;

      .selection-label {
        font-size: 14px;
        color: #666;
        white-space: nowrap;
      }

      .file-radio-group {
        display: flex;
        gap: 10px;
      }

      .company-select {
        width: 200px;
      }
    }
  }

  .preview-content {
    flex: 1;
    margin-bottom: 20px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    overflow: hidden;
  }

  .preview-actions {
    text-align: center;

    .recommend-btn {
      background-color: #409EFF;
      color: white;
      border: none;
      border-radius: 6px;
      padding: 10px 20px;
      font-size: 14px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.25s;

      &:hover {
        background-color: #66b1ff;
      }
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  /deep/ .commitment-dialog {
    width: 95% !important;
    margin: 20px auto !important;

    .el-dialog__body {
      max-height: 60vh;
    }
  }

  .commitment-content {
    padding: 16px;

    .commitment-header {
      flex-direction: column;
      align-items: flex-start;

      .commitment-type {
        margin-left: 0;
        margin-top: 12px;
      }
    }

  }
}

// 回避弹窗样式
/deep/ .avoid-dialog {
  border-radius: 8px;
  overflow: hidden;

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 30px;
  }

  .el-dialog__footer {
    padding: 0 30px 30px;
    border-top: none;
  }
}

.avoid-content {
  .avoid-title {
    font-size: 20px;
    font-weight: bold;
    color: #e6393d;
    margin-bottom: 24px;
  }

  .avoid-section {
    margin-bottom: 16px;

    .avoid-label {
      font-size: 15px;
      font-weight: bold;
      color: #333;
      margin-bottom: 8px;
    }

    .avoid-value-box {
      background-color: #f7f7f7;
      border: 1px solid #eee;
      border-radius: 4px;
      padding: 12px 16px;
      font-size: 14px;
      color: #333;
    }
  }
}

.avoid-footer {
  display: flex;
  justify-content: space-between;
}
</style>